export const sortBySpecificColumn = (a: any, b: any, p: string) =>
  a[p] > b[p] ? 1 : a[p] < b[p] ? -1 : 0;

export const sortDescBySpecificColumn = (a: any, b: any, p: string) =>
  a[p] < b[p] ? 1 : a[p] > b[p] ? -1 : 0;

export const groupBy = (list: any, key: any) =>
  list?.reduce((rv: any, x: any) => {
    // eslint-disable-next-line no-param-reassign
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});

export const safeSlice = <T,>(arr: T[] | undefined | null, start = 0, end?: number): T[] => {
  if (!Array.isArray(arr)) return [];
  return arr.slice(start, end);
};

export const mapByIdOrName = <T extends { id: number; name?: string }>(
  source: T[],
  input?: (Partial<T> | number | string)[]
): T[] => {
  if (!input || input.length === 0) return [];
  return input
    .map((v) => {
      if (typeof v === "number") return source.find((s) => s.id === v);
      if (typeof v === "string") {
        const asNum = parseInt(v as string, 10);
        if (!Number.isNaN(asNum)) return source.find((s) => s.id === asNum);
        return source.find((s) => (s.name ?? "").toLowerCase() === v.toLowerCase());
      }
      if (typeof v === "object" && v) {
        if (typeof v.id === "number") return source.find((s) => s.id === v.id);
        if (v.name) return source.find((s) => (s.name ?? "").toLowerCase() === String(v.name).toLowerCase());
      }
      return undefined;
    })
    .filter(Boolean) as T[];
};